import {
  getCampaignIntegrationStatus,
  type CampaignIntegrationStatusInput,
} from "@/features/campaigns/jobboards/utils/getCampaignIntegrationStatus";

export type CampaignStatus = "active" | "paused" | "inactive";

export type CampaignStatusInfo = {
  status: CampaignStatus;
  labelKey: string;
  variant: "success" | "warning" | "neutral";
};

export function getCampaignStatus(
  integrations: CampaignIntegrationStatusInput[]
): CampaignStatusInfo {
  const list = integrations ?? [];

  const hasActive = list.some(
    (i) => getCampaignIntegrationStatus(i) === "active"
  );
  if (hasActive) {
    return { status: "active", labelKey: "common.active", variant: "success" };
  }

  const hasPaused = list.some(
    (i) => getCampaignIntegrationStatus(i) === "paused"
  );
  if (hasPaused) {
    return { status: "paused", labelKey: "common.paused", variant: "warning" };
  }

  return { status: "inactive", labelKey: "common.inactive", variant: "neutral" };
}
